module.exports = __webpack_public_path__ + "static/GlitchlessSonyax5e-460125c5eb4ce69cb3ea39f7dc8c68b3.png";